<template>
  <div>
    <div class="card card-custom mb-5">
      <div class="card-header h-auto py-2">
        <div class="card-title">
          <h3 class="card-label">
            Serial Number:
            {{ currentItem.ATGSeriesNumber | numFormat("000000") }}
          </h3>
        </div>
        <div class="card-toolbar">
          <a :href="currentItem.FileUrl" target="_blank">
            <button
              class="align-self-start btn btn-sm btn-secondary mx-1"
              type="button"
            >
              Download PDF
            </button>
          </a>
          <!-- <button
            class="align-self-start btn btn-sm btn-secondary mx-1"
            type="button"
          >
            Send Receipt/Invoice by Email
          </button> -->
          <button
            class="align-self-start btn btn-sm btn-secondary mx-1"
            type="button"
            @click="confirmCancelTransaction"
            v-if="currentItem.Status !== 'Cancelled' && currentItem.ATGSeriesType !== 'Void'"
          >
            Cancel Sale
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">ATG#:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.ATGClientId
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Type:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.MetadataObject.ATGSeriesType
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Transaction Date:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.TransactionDateTime | moment("LLLL")
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Last ATG Check:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.LastATGCheck | moment("LLLL")
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Source:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">{{ currentItem.Source }} - {{ currentItem.SourceIdentifier }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Status:</label>
              <div class="col-8 ">
                <span
                  class="badge"
                  :class="{
                    'badge-success': currentItem.Status !== 'Cancelled',
                    'badge-danger': currentItem.Status === 'Cancelled'
                  }"
                  >{{ currentItem.Status }}</span
                >
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4 col-form-label">Created:</label>
              <div class="col-8">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.CreatedDateTime | moment("LLLL")
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4 col-form-label">Created By:</label>
              <div class="col-8">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.CreatedBy
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        <div class="card card-custom mb-5">
          <div class="card-header h-auto py-2">
            <div class="card-title">
              <h3 class="card-label">Business / Branch</h3>
            </div>
          </div>
          <div class="card-body py-4">
            <div class="row">
              <div class="col-12">
                <div class="form-group row my-1">
                  <label class="col-4 col-md-3 col-form-label">Name:</label>
                  <div class="col-8 col-md-9">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.BusinessProfile.DisplayName
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-3 col-form-label">RDO:</label>
                  <div class="col-8 col-md-9">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.BusinessProfile.RDO
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-3 col-form-label">TIN:</label>
                  <div class="col-8 col-md-9">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.BusinessProfile.TIN + "-" + currentItem.MetadataObject.BusinessProfile.BranchCode
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card card-custom mb-5">
          <div class="card-header h-auto py-2">
            <div class="card-title">
              <h3 class="card-label">Buyer</h3>
            </div>
          </div>
          <div class="card-body py-4">
            <div class="row">
              <div class="col-12">
                <div class="form-group row my-1">
                  <label class="col-4 col-md-4 col-form-label">Name:</label>
                  <div class="col-8 col-md-8">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.Buyer.Name
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-4 col-form-label">Address:</label>
                  <div class="col-8 col-md-8">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.Buyer.Address
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-4 col-form-label">TIN:</label>
                  <div class="col-8 col-md-8">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.Buyer.TIN + "-" + ((currentItem.MetadataObject.Buyer.BranchCode != null)? currentItem.MetadataObject.Buyer.BranchCode : "00000")
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-4 col-form-label">Business style:</label>
                  <div class="col-8 col-md-8">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.Buyer.BusinessStyle
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card card-custom mb-5">
          <div class="card-header h-auto py-2">
            <div class="card-title">
              <h3 class="card-label">Payment</h3>
            </div>
          </div>
          <div class="card-body py-4">
            <div class="row">
              <div class="col-12">
                <div v-if="currentItem.MetadataObject.ATGSeriesType == 'Services'" class="form-group row my-1">
                  <label class="col-4 col-md-4 col-form-label">Nature of Service:</label>
                  <div class="col-8 col-md-8">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.NatureOfService
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-6 col-form-label">Payment Type:</label>
                  <div class="col-8 col-md-6">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.Payment.PaymentType
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-6 col-form-label">Type of sale:</label>
                  <div class="col-8 col-md-6">
                    <span v-if="currentItem.MetadataObject.ATGSeriesType == 'Services'" class="form-control-plaintext font-weight-bolder">na</span>
                    <span v-else class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.Payment.TypeOfSale
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-6 col-form-label">Form of payment:</label>
                  <div class="col-8 col-md-6">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.Payment.Mode
                    }}</span>
                  </div>
                </div>
                <div class="form-group row my-1">
                  <label class="col-4 col-md-6 col-form-label">Type of e-payment:</label>
                  <div class="col-8 col-md-6">
                    <span class="form-control-plaintext font-weight-bolder">{{
                      currentItem.MetadataObject.Payment.TypeOfEPayment
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-8">
        <div class="card card-custom mb-8">
          <div class="card-header h-auto">
            <div class="card-title">
              <h3 class="card-label">Items</h3>
            </div>
          </div>
          <div class="card-body py-4">
            <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Description</th>
                        <th scope="col">Qty</th>
                        <th scope="col">Unit</th>
                        <th scope="col" class="text-right">Price</th>
                        <th scope="col" class="text-right" v-if="currentItem.MetadataObject.DiscountComputation === 'ByItem'">Deductions</th>
                        <th scope="col" class="text-right">Line Total</th>
                        <th scope="col" v-if="currentItem.MetadataObject.DiscountComputation === 'ByItem'">Discounts</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in currentItem.MetadataObject.Items"
                        :key="item.ItemId"
                      >
                        <td>{{ item.Description }}</td>
                        <td>{{ item.Quantity | numFormat("0,0") }}</td>
                        <td>{{ item.Unit }}</td>
                        <td class="text-right">{{ item.Price | numFormat("0,0.00") }}</td>
                        <td class="text-right" v-if="currentItem.MetadataObject.DiscountComputation === 'ByItem'">{{ item.Deductions | numFormat("0,0.00") }}</td>
                        <td class="text-right">{{ item.LineTotal | numFormat("0,0.00") }}</td>
                        <td v-if="currentItem.MetadataObject.DiscountComputation === 'ByItem'">
                          <div v-for="(item, index) in item.Discounts" :key="'item_discount_item_' + index">
                            {{ item.DiscountDisplayText }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- VAT Breakdown -->
        <div v-if="currentItem.MetadataObject.TaxMode != ''" class="row">
          <div class="col-12 col-md-6">
            <!-- VAT Inclusive -->
            <div class="card card-custom mb-5">
              <div class="card-header h-auto py-2">
                <div class="card-title">
                  <h3 class="card-label">Totals</h3>
                </div>
              </div>
              <div class="card-body py-4">
                <div class="row">
                  <div v-for="(item, index) in totalSalesItems" :key="'total_item_' + index" class="col-12">
                    <div class="form-group row my-1">
                      <label class="col-6 col-form-label">{{ item.label }}</label>
                      <div class="col-6">
                        <span
                          class="form-control-plaintext font-weight-bolder text-right"
                          >{{
                            item.value | numFormat("0,0.00")
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="card card-custom mb-5">
              <div class="card-header h-auto py-2">
                <div class="card-title">
                  <h3 class="card-label">VAT Breakdown</h3>
                </div>
              </div>
              <div class="card-body py-4">
                <div class="row">
                  <div v-for="(item, index) in vatBreakdownItems" :key="'total_item_' + index" class="col-12">
                    <div class="form-group row my-1">
                      <label class="col-6 col-form-label">{{ item.label }}</label>
                      <div class="col-6">
                        <span
                          class="form-control-plaintext font-weight-bolder text-right"
                          >{{
                            item.value | numFormat("0,0.00")
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card card-custom mb-5" v-if="currentItem.MetadataObject.Discounts != null && currentItem.MetadataObject.Discounts.length>0">
          <div class="card-header h-auto py-2">
            <div class="card-title">
              <h3 class="card-label">Discounts / {{currentItem.MetadataObject.DiscountComputation}}</h3>
            </div>
          </div>
          <div class="card-body py-4">
            <div class="row">
              <div v-for="(item, index) in currentItem.MetadataObject.Discounts" :key="'discount_item_' + index" class="col-12">
                <div class="form-group row my-1">
                  <div class="col-12">
                        <span class="form-control-plaintext">{{item.DiscountDisplayText}} - {{item.Name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Totals -->
        <div v-if="currentItem.MetadataObject.TaxMode == ''" class="card card-custom mb-5">
          <div class="card-header h-auto py-2">
            <div class="card-title">
              <h3 class="card-label">Totals</h3>
            </div>
          </div>
          <div class="card-body py-4">
            <div class="row">
              <div class="col-12">
                <div class="form-group row my-1">
                  <label class="col-6 col-form-label">Subtotal:</label>
                  <div class="col-6">
                    <span
                      class="form-control-plaintext font-weight-bolder text-right"
                      >{{
                        currentItem.MetadataObject.Totals.TotalSales
                          | numFormat("0,0.00")
                      }}</span
                    >
                  </div>
                  <label class="col-6 col-form-label">Total Deductions:</label>
                  <div class="col-6">
                    <span
                      class="form-control-plaintext font-weight-bolder text-right"
                      >{{
                        currentItem.MetadataObject.Totals.TotalDeductions
                          | numFormat("0,0.00")
                      }}</span
                    >
                  </div>
                  <label class="col-6 col-form-label">Total Amount:</label>
                  <div class="col-6">
                    <span
                      class="form-control-plaintext font-weight-bolder text-right"
                      >{{
                        currentItem.MetadataObject.Totals.TotalAmount
                          | numFormat("0,0.00")
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Remarks -->
        <div class="card card-custom mb-5">
          <div class="card-header h-auto py-2">
            <div class="card-title">
              <h3 class="card-label">Remarks</h3>
            </div>
          </div>
          <div class="card-body py-4">
            {{
              currentItem.MetadataObject.Remarks
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";
import Swal from "sweetalert2";

Vue.use(require("vue-moment"));
Vue.filter("numFormat", numFormat(numeral));

Vue.use(require("vue-moment"));
export default {
  components: {},
  props: ["propdata"],
  data() {
    return {
      isBusy: false,
      tabIndex: 0,
      currentItem: {},
      files: [],
      totalSalesItems: [],
      vatBreakdownItems: []
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
      this.setBreadcrumbs(this.propdata.ShortCode);
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreciept"
        },
        {
          title: "Sales",
          route: "/easyreceipt/sales"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    getData() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = { TransactionId: self.propdata.TransactionId };
        ApiService.get("sales/getbyid", param)
          .then(({ data }) => {
            this.$gtag.event("sales_getbyid");
            self.isBusy = false;
            if (data) {
              self.currentItem = data;
              self.currentItem.FileUrl =
                ApiService.baseUrl +
                "files/" +
                self.currentItem.TransactionId +
                ".pdf";
              // console.log(
              //   "self.currentItem.FileUrl:",
              //   self.currentItem.FileUrl
              // );
              self.renderTotals();
            }
            resolve(data);
          })
          .catch(({ response }) => {
            self.isBusy = false;
            reject(response);
          });
      });
    },
    renderTotals() {
      if(this.currentItem.MetadataObject.TaxMode == 'VAT Inclusive') {
        this.totalSalesItems = [
          {
            label : 'Subtotal (VAT Inclusive)',
            value : this.currentItem.MetadataObject.Totals.TotalSales
          },
          {
            label : 'Less: VAT',
            value : this.currentItem.MetadataObject.Totals.LessVat
          },
          {
            label : 'Net VAT Amount',
            value : this.currentItem.MetadataObject.Totals.NetVat
          },
          {
            label : 'Less: Discount',
            value : this.currentItem.MetadataObject.Totals.TotalDeductions
          },
          {
            label : 'Add VAT',
            value : this.currentItem.MetadataObject.Totals.AddVat
          },
          {
            label : 'Total',
            value : this.currentItem.MetadataObject.Totals.TotalAmount
          }
        ];
      } else {
        this.totalSalesItems = [
          {
            label : 'Gross Sales (VAT Exclusive)',
            value : this.currentItem.MetadataObject.Totals.GrossSales
          },
          {
            label : 'Less: Discount',
            value : this.currentItem.MetadataObject.Totals.TotalDeductions
          },
          {
            label : 'Net Sales',
            value : this.currentItem.MetadataObject.Totals.TotalSales
          },
          {
            label : 'Add VAT',
            value : this.currentItem.MetadataObject.Totals.AddVat
          },
          {
            label : 'Total',
            value : this.currentItem.MetadataObject.Totals.TotalAmount
          }
        ];
      }

      // VAT Breakdowns
      this.vatBreakdownItems = [
        {
          label : 'VATable Sales',
          value : this.currentItem.MetadataObject.Totals.VatableSales
        },
        {
          label : 'VAT-exempt Sales',
          value : this.currentItem.MetadataObject.Totals.VatExemptSales
        },
        {
          label : 'Zero Rated Sales',
          value : this.currentItem.MetadataObject.Totals.ZeroRatedSales
        },
        {
          label : 'VAT Amount',
          value : this.currentItem.MetadataObject.Totals.VatAmount
        }
      ];
    },
    confirmCancelTransaction() {
      let self = this;
      Swal.fire({
        //title: 'Are you sure?',
        html: "Are you sure you want to cancel this transaction?",
        icon: "warning",
        input: "textarea",
        inputLabel: "Reason for the cancellation",
        inputPlaceholder: "Reason for the cancellation",
        inputAttributes: {
          "aria-label": "Reason for the cancellation"
        },
        inputValidator: (value) => {
          if (!value) {
            return "Please enter your reason for the cancellation.";
          }
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        // console.log('result:', result);
        if (result.isConfirmed) {
          self.cancelTransaction(result.value);
        }
      });
    },
    cancelTransaction(reason) {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = { TransactionId: self.currentItem.TransactionId, Reason: reason };
        ApiService.post("sales/cancel", param)
          .then(({ data }) => {
            this.$gtag.event("sales_cancel");
            self.isBusy = false;
            if (data) {
              self.currentItem = data;
              self.currentItem.FileUrl =
                ApiService.baseUrl +
                "files/" +
                self.currentItem.TransactionId +
                ".pdf?nocache=" + new Date().getTime();
            }
            resolve(data);
          })
          .catch(({ response }) => {
            self.isBusy = false;
            reject(response);
          });
      });
    }
  },
  watch: {}
};
</script>

<style>
.col-form-label,
.form-control-plaintext {
  padding-top: 0px;
  padding-bottom: 0px;
}

.card.card-custom > .card-header {
  min-height: 50px;
}
</style>
